import { createSelector } from 'reselect';
import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { NAV_MODULE_NAME } from '../constants/modules';

const navModuleStateSelector = createModuleStateSelector(NAV_MODULE_NAME);

export const logoutLinkSelector = createSelector(
  navModuleStateSelector,
  (state) => state?.getIn(['navData', 'generalLinks', 'logout'])
);
